/* ryfix-cart: audit fixes, workstream cart (28 Sep 2026)
 *
 * 1. Cart drawer behaves as a modal dialog: focus moves in, is trapped, Esc closes, focus returns to the trigger.
 * 2. Quantity changes and Remove: real error handling (the cart is re-read when Shopify rejects a quantity),
 *    focus is kept after the list re-renders, and results are announced politely.
 * 3. Discount code: applied to the real cart through /cart/update.js, with honest feedback.
 * 4. Order note: saved on change.
 * 5. Cart icon label ("Cart, 2 items") kept in sync.
 *
 * Delivery copy and thresholds are rendered by Liquid (snippets/cart-addons.liquid, part "totals") and arrive here
 * through section rendering, so there is one source of truth. This file never computes delivery text itself.
 */
(function () {
  'use strict';
  if (window.__rycInit) return;
  window.__rycInit = true;

  var doc = document;
  var FOCUSABLE =
    'a[href],button:not([disabled]),input:not([disabled]):not([type="hidden"]),select:not([disabled]),' +
    'textarea:not([disabled]),summary,[tabindex]:not([tabindex="-1"])';
  var SWAP = ['[data-minimog-cart-items]', '[data-minimog-cart-discounts]', '[data-cart-subtotal]', '[data-minimog-gift-wrapping]'];
  var GENERIC_ERROR = 'We could not update your cart. Check your connection and try again.';

  function $(sel, root) { return (root || doc).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || doc).querySelectorAll(sel)); }
  function route(name, fallback) {
    var r = window.MinimogSettings && window.MinimogSettings.routes;
    return (r && r[name]) || fallback;
  }
  function visible(el) {
    return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length) && getComputedStyle(el).visibility !== 'hidden';
  }
  function focusEl(el) {
    if (!el) return false;
    try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); }
    return doc.activeElement === el;
  }
  function money(cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'NZD';
    var n = (Math.round(cents) / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return cur === 'NZD' ? 'NZ$' + n : n + ' ' + cur;
  }
  function request(url, body) {
    var opts = { credentials: 'same-origin', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } };
    if (body !== undefined) {
      opts.method = 'POST';
      opts.headers['Content-Type'] = 'application/json';
      opts.body = JSON.stringify(body);
    }
    return fetch(url, opts).then(function (r) {
      return r.text().then(function (t) {
        var data = null;
        try { data = JSON.parse(t); } catch (e) { /* HTML error page */ }
        return { ok: r.ok, status: r.status, data: data };
      });
    });
  }
  /* The cart being worked on: the /cart page (m-cart) or the drawer. Set per operation from the element that
     started it, so a page that has both never re-renders the wrong one. */
  var activeRoot = null;
  function useRoot(el) {
    activeRoot = (el && el.closest && (el.closest('m-cart') || el.closest('m-cart-drawer'))) || null;
  }
  function cartRoot() { return (activeRoot && doc.contains(activeRoot) && activeRoot) || $('m-cart') || $('m-cart-drawer'); }
  function sectionName() { var r = cartRoot(); return r && r.tagName === 'M-CART' ? 'cart-template' : 'cart-drawer'; }

  /* ---------- polite announcements ---------- */
  var liveTimer;
  function announce(msg) {
    var region = $('[data-ryc-live]');
    if (!region || !msg) return;
    clearTimeout(liveTimer);
    region.textContent = '';
    liveTimer = setTimeout(function () { region.textContent = msg; }, 120);
  }
  function totalsText() {
    var el = $('[data-ryc-delivery]', cartRoot() || doc);
    return (el && el.getAttribute('data-ryc-announce')) || '';
  }

  /* ---------- section swap (Liquid is the source of truth) ---------- */
  function swapFromHTML(html) {
    var root = cartRoot();
    if (!root || !html) return false;
    var fresh = new DOMParser().parseFromString(html, 'text/html');
    var done = false;
    SWAP.forEach(function (sel) {
      var from = fresh.querySelector(sel);
      var to = root.querySelector(sel);
      if (from && to) { to.innerHTML = from.innerHTML; done = true; }
    });
    return done;
  }
  function setEmpty(count) {
    var empty = count === 0;
    $$('m-cart, m-cart-drawer, m-cart-drawer-items').forEach(function (el) { el.classList.toggle('m-cart--empty', empty); });
  }
  function setCount(count) {
    $$('.m-cart-count-bubble').forEach(function (b) {
      if (count > 0) { b.textContent = count; b.classList.remove('m:hidden'); } else { b.classList.add('m:hidden'); }
    });
    $$('.m-cart-icon-bubble').forEach(function (a) {
      a.setAttribute('aria-label', 'Cart, ' + count + (count === 1 ? ' item' : ' items'));
    });
  }
  function emitUpdate(state) {
    try {
      if (window.MinimogEvents && window.MinimogTheme) {
        var payload = {};
        for (var k in state) payload[k] = state[k];
        payload.source = 'main-cart-items';
        MinimogEvents.emit(MinimogTheme.pubSubEvents.cartUpdate, payload);
      }
      doc.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: state } }));
    } catch (e) { /* non-critical */ }
  }
  function applyState(state) {
    var html = state.sections && state.sections[sectionName()];
    setEmpty(state.item_count);
    swapFromHTML(html);
    setCount(state.item_count);
  }
  /* Re-read the real cart and re-render from it. Used when Shopify answers with an error, because the cart may
     still have changed (for example a quantity capped at the stock level). */
  function resync() {
    /* An empty update returns the current cart and its freshly rendered section in one consistent answer
       (a separate GET of the section could still show the state from before the rejected change). */
    return request(route('cart_update_url', '/cart/update').replace(/\.js$/, '') + '.js', {
      updates: {}, sections: [sectionName()], sections_url: window.location.pathname
    }).then(function (c) {
      if (!c.ok || !c.data || c.data.status) throw new Error('cart');
      applyState(c.data);
      return c.data;
    });
  }

  /* ---------- line messages ---------- */
  function lineNode(line) {
    return doc.getElementById('MinimogCart-Item-' + line) || doc.getElementById('MinimogCartDrawer-Item-' + line);
  }
  function lineMessage(line, msg) {
    $$('.ryc-line-msg').forEach(function (n) { n.remove(); });
    var p = doc.createElement('p');
    p.className = 'ryc-line-msg';
    p.setAttribute('role', 'alert');
    p.textContent = msg;
    var node = lineNode(line);
    if (node) node.appendChild(p);
    else {
      var list = $('[data-minimog-cart-items]', cartRoot() || doc);
      if (list) list.insertBefore(p, list.firstChild);
    }
  }

  /* ---------- focus memory across re-renders ---------- */
  function rememberFocus() {
    var ae = doc.activeElement;
    var item = ae && ae.closest && ae.closest('[data-cart-item]');
    if (!item) return null;
    var m = /-Item-(\d+)$/.exec(item.id || '');
    var kind = 'qty';
    if (ae.closest('m-cart-remove-button')) kind = 'remove';
    else if (ae.name === 'minus' || ae.name === 'plus') kind = ae.name;
    return { line: m ? parseInt(m[1], 10) : 1, kind: kind };
  }
  function restoreFocus(key) {
    if (!key) return;
    var ae = doc.activeElement;
    if (ae && ae !== doc.body && doc.contains(ae)) return;
    var root = cartRoot();
    if (!root) return;
    var items = $$('[data-cart-item]', root);
    if (!items.length) {
      focusEl($('.ryc-empty__cta', root)) || focusEl($('.m-cart-drawer__close', root));
      return;
    }
    var item = items[Math.min(key.line, items.length) - 1];
    var sel = { remove: 'm-cart-remove-button button', minus: 'button[name="minus"]', plus: 'button[name="plus"]', qty: '.m-quantity__input' };
    focusEl($(sel[key.kind], item)) || focusEl($('.m-quantity__input', item)) || focusEl($('a[href]', item));
  }

  /* ---------- quantity and remove ---------- */
  function patchQuantity(Klass) {
    if (!Klass || Klass.prototype.__rycPatched) return;
    Klass.prototype.__rycPatched = true;
    Klass.prototype.updateQuantity = function (line, quantity) {
      var host = this;
      useRoot(host);
      line = parseInt(line, 10);
      var node = lineNode(line);
      var input = node && $('.m-quantity__input', node);
      var title = node && $('.m-cart-item__title', node);
      var name = title ? title.textContent.trim() : 'Item';
      var prev = input ? parseInt(input.getAttribute('value'), 10) : NaN;
      var qty = parseInt(quantity, 10);
      var note = '';

      if (isNaN(qty) || qty < 0) {
        if (input && !isNaN(prev)) input.value = prev;
        lineMessage(line, 'Enter a quantity of 1 or more.');
        return;
      }
      var max = input && input.max ? parseInt(input.max, 10) : NaN;
      if (!isNaN(max) && qty > max) {
        qty = max;
        note = 'Only ' + max + ' available. Quantity set to ' + max + '.';
        if (input) input.value = max;
        if (qty === prev) { lineMessage(line, note); return; }
      }

      var key = rememberFocus();
      if (host.loading) host.loading.start();
      var sections = [sectionName()];
      request(route('cart_change_url', '/cart/change'), {
        line: line, quantity: qty, sections: sections, sections_url: window.location.pathname
      })
        .then(function (res) {
          var state = res.data;
          if (!res.ok || !state || state.errors || state.status) {
            var msg = state && (typeof state.errors === 'string' ? state.errors : state.description || state.message);
            return resync().then(function () {
              restoreFocus(key);
              lineMessage(line, msg || GENERIC_ERROR);
            });
          }
          applyState(state);
          restoreFocus(key);
          if (note) lineMessage(line, note);
          if (qty === 0) sayTotals(name + ' removed from cart. ');
          emitUpdate(state);
        })
        .catch(function () {
          if (input && !isNaN(prev)) input.value = prev;
          lineMessage(line, GENERIC_ERROR);
        })
        .then(function () { if (host.loading) host.loading.finish(); });
    };
  }
  if (window.customElements) {
    customElements.whenDefined('m-cart').then(function () { patchQuantity(customElements.get('m-cart')); });
    customElements.whenDefined('m-cart-drawer-items').then(function () { patchQuantity(customElements.get('m-cart-drawer-items')); });
  }

  /* ---------- announce totals whenever the summary is re-rendered ---------- */
  var lastTotals = '';
  var prefix = '';
  var totalsTimer;
  function sayTotals(lead) {
    if (lead) prefix = lead;
    clearTimeout(totalsTimer);
    totalsTimer = setTimeout(function () {
      var t = totalsText();
      if (!t || (t === lastTotals && !prefix)) return;
      lastTotals = t;
      announce((prefix || 'Cart updated. ') + t);
      prefix = '';
    }, 600);
  }
  function watchTotals() {
    var root = cartRoot();
    var box = root && $('[data-cart-subtotal]', root);
    if (!box || box.__ryc || !window.MutationObserver) return;
    box.__ryc = true;
    lastTotals = totalsText();
    new MutationObserver(function () { sayTotals(); }).observe(box, { childList: true, subtree: true, characterData: true });
  }
  doc.addEventListener('product-ajax:added', function () { sayTotals('Added to cart. '); });

  /* ---------- cart icon label follows the count bubble (which Minimog updates) ---------- */
  function watchCount() {
    if (!window.MutationObserver) return;
    $$('.m-cart-count-bubble').forEach(function (b) {
      if (b.__ryc) return;
      b.__ryc = true;
      new MutationObserver(function () {
        var n = b.classList.contains('m:hidden') ? 0 : parseInt(b.textContent, 10) || 0;
        var link = b.closest('.m-cart-icon-bubble');
        if (link) link.setAttribute('aria-label', 'Cart, ' + n + (n === 1 ? ' item' : ' items'));
      }).observe(b, { childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    });
  }

  /* ---------- drawer as a modal dialog ---------- */
  function initDrawer() {
    var drawer = $('m-cart-drawer');
    if (!drawer || drawer.__rycDialog) return;
    drawer.__rycDialog = true;
    var panel = $('.m-cart-drawer__inner', drawer);
    var isOpen = drawer.classList.contains('m-cart-drawer--active');
    var armed = false;
    var returnTo = null;
    var lastTrigger = null;

    if (!isOpen) drawer.setAttribute('inert', '');

    doc.addEventListener('click', function (e) {
      if (isOpen || !e.target.closest || drawer.contains(e.target)) return;
      lastTrigger = e.target.closest('a,button,[role="button"],summary,input');
    }, true);

    function focusables() {
      return $$(FOCUSABLE, panel).filter(visible);
    }
    function onOpen() {
      isOpen = true;
      armed = false;
      drawer.removeAttribute('inert');
      var ae = doc.activeElement;
      returnTo = drawer.activeElement || (ae && ae !== doc.body && !drawer.contains(ae) ? ae : lastTrigger);
      drawer.activeElement = null;
      focusEl($('.m-cart-drawer__close', drawer)) || focusEl(panel);
    }
    function onClose() {
      if (!isOpen) return;
      isOpen = false;
      armed = false;
      drawer.setAttribute('inert', '');
      var target = returnTo && doc.contains(returnTo) && visible(returnTo) ? returnTo : $$('.m-cart-icon-bubble').filter(visible)[0];
      returnTo = null;
      focusEl(target);
    }

    if (window.MutationObserver) {
      new MutationObserver(function (list) {
        list.forEach(function (m) {
          var active = drawer.classList.contains('m-cart-drawer--active');
          if (m.attributeName === 'class') {
            if (active && !isOpen) onOpen();
            else if (!active && isOpen) onClose();
          } else if (m.attributeName === 'style' && isOpen) {
            var o = drawer.style.getPropertyValue('--m-bg-opacity').trim();
            if (o === '0.5') armed = true;
            else if (o === '0' && armed) onClose();
          }
        });
      }).observe(drawer, { attributes: true, attributeFilter: ['class', 'style'] });
    }

    doc.addEventListener('keydown', function (e) {
      if (!isOpen) return;
      if (e.key === 'Escape' || e.key === 'Esc') {
        e.preventDefault();
        if (typeof drawer.close === 'function') drawer.close();
        return;
      }
      if (e.key !== 'Tab') return;
      var f = focusables();
      if (!f.length) { e.preventDefault(); focusEl(panel); return; }
      var first = f[0];
      var last = f[f.length - 1];
      var ae = doc.activeElement;
      if (!panel.contains(ae) || ae === panel) {
        e.preventDefault();
        focusEl(e.shiftKey ? last : first);
      } else if (e.shiftKey && ae === first) {
        e.preventDefault();
        focusEl(last);
      } else if (!e.shiftKey && ae === last) {
        e.preventDefault();
        focusEl(first);
      }
    }, true);
  }

  /* ---------- discount code ---------- */
  function initDiscount(box) {
    if (box.__ryc) return;
    box.__ryc = true;
    var input = $('[data-ryc-discount-input]', box);
    var apply = $('[data-ryc-discount-apply]', box);
    var remove = $('[data-ryc-discount-remove]', box);
    var msg = $('[data-ryc-discount-msg]', box);
    var label = $('[data-ryc-discount-label]', box);
    if (!input || !apply) return;
    var applied = box.getAttribute('data-ryc-applied') || '';
    var busy = false;

    /* The code is applied to the cart itself, so the field must not also post to checkout. */
    input.removeAttribute('name');
    input.removeAttribute('form');

    function say(text, state) {
      msg.textContent = text;
      msg.className = 'ryc-addon__msg' + (state ? ' ryc-addon__msg--' + state : '');
      if (state === 'error') input.setAttribute('aria-invalid', 'true');
      else input.removeAttribute('aria-invalid');
    }
    var sub = $('[data-ryc-discount-sub]', box);
    function paint() {
      label.textContent = applied ? 'Discount code ' + applied + ' applied' : 'Have a discount code?';
      if (sub) sub.hidden = !!applied;
      if (remove) remove.hidden = !applied;
    }
    function setBusy(on) {
      busy = on;
      apply.disabled = on;
      if (remove) remove.disabled = on;
      apply.textContent = on ? 'Checking' : 'Apply';
    }
    function send(code) {
      return request(route('cart_update_url', '/cart/update'), {
        discount: code, sections: [sectionName()], sections_url: window.location.pathname
      }).then(function (res) {
        if (!res.ok || !res.data || res.data.status) throw new Error('request');
        return res.data;
      });
    }
    function run(code) {
      if (busy) return;
      useRoot(box);
      code = (code || '').trim();
      if (!code) { say('Enter a discount code.', 'error'); focusEl(input); return; }
      setBusy(true);
      say('', '');
      send(code)
        .then(function (state) {
          var hit = (state.discount_codes || []).filter(function (d) {
            return String(d.code).toLowerCase() === code.toLowerCase();
          })[0];
          if (hit && hit.applicable) {
            applied = String(hit.code).toUpperCase();
            input.value = applied;
            applyState(state);
            emitUpdate(state);
            var saved = state.total_discount > 0 ? ' You save ' + money(state.total_discount) + '.' : '';
            say(applied + ' applied.' + saved, 'ok');
            paint();
            return;
          }
          /* Not valid for this cart: put the cart back as it was so it does not carry a dead code. */
          return send(applied).then(function (back) {
            applyState(back);
            emitUpdate(back);
            say('That code cannot be used on this order. Check the spelling, or whether it has expired.', 'error');
            paint();
            focusEl(input);
          });
        })
        .catch(function () {
          say('We could not check that code just now. Try again, or enter it at checkout.', 'error');
        })
        .then(function () { setBusy(false); });
    }

    apply.addEventListener('click', function () { run(input.value); });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); run(input.value); }
    });
    if (remove) {
      remove.addEventListener('click', function () {
        if (busy) return;
        useRoot(box);
        setBusy(true);
        send('')
          .then(function (state) {
            applied = '';
            input.value = '';
            applyState(state);
            emitUpdate(state);
            say('Discount code removed.', 'ok');
            paint();
            focusEl(input);
          })
          .catch(function () { say('We could not remove the code just now. Try again.', 'error'); })
          .then(function () { setBusy(false); });
      });
    }
  }

  /* ---------- order note ---------- */
  function initNote(box) {
    if (box.__ryc) return;
    box.__ryc = true;
    var area = $('[data-ryc-note-input]', box);
    var msg = $('[data-ryc-note-msg]', box);
    if (!area) return;
    var saved = area.value;
    area.addEventListener('change', function () {
      if (area.value === saved) return;
      var value = area.value;
      request(route('cart_update_url', '/cart/update'), { note: value })
        .then(function (res) {
          if (!res.ok) throw new Error('note');
          saved = value;
          msg.textContent = value ? 'Note saved.' : 'Note removed.';
          msg.className = 'ryc-addon__msg ryc-addon__msg--ok';
        })
        .catch(function () {
          msg.textContent = 'We could not save the note just now. It will still be sent when you check out.';
          msg.className = 'ryc-addon__msg ryc-addon__msg--error';
        });
    });
  }

  /* ---------- add to cart never fails silently ----------
     Minimog's product form (theme-global.js, not editable) reads every /cart/add answer as JSON and only shows a
     message when that JSON carries a status. A rate limit, server error or dropped connection threw inside its
     promise chain and nothing was shown. Those failures are turned into the same JSON shape the theme already
     displays, and every add-to-cart error is also announced to screen readers. */
  var ADD_ERROR = 'We could not add this to your cart. Check your connection and try again.';
  var pageAlert;
  function alertPage(msg) {
    if (!msg || !doc.body) return;
    if (!pageAlert) {
      pageAlert = doc.createElement('p');
      pageAlert.className = 'm:visually-hidden';
      pageAlert.setAttribute('role', 'alert');
      doc.body.appendChild(pageAlert);
    }
    pageAlert.textContent = '';
    setTimeout(function () { pageAlert.textContent = msg; }, 120);
  }
  if (window.fetch && window.Response && !window.fetch.__ryc) {
    var nativeFetch = window.fetch;
    var wrapped = function (input, init) {
      var args = arguments;
      var url = String((input && input.url) || input || '');
      var method = String((init && init.method) || (input && input.method) || 'GET').toUpperCase();
      if (method !== 'POST' || !/\/cart\/add(\.js)?(\?|$)/.test(url)) return nativeFetch.apply(window, args);
      function fail(status) {
        alertPage(ADD_ERROR);
        setTimeout(function () {
          request(route('cart', '/cart') + '.js').then(function (c) { if (c.ok && c.data) setEmpty(c.data.item_count); });
        }, 50);
        var body = JSON.stringify({ status: status, message: ADD_ERROR, description: ADD_ERROR });
        return new Response(body, { status: status, headers: { 'Content-Type': 'application/json' } });
      }
      return nativeFetch.apply(window, args).then(function (res) {
        if (res.ok) return res;
        var type = res.headers.get('content-type') || '';
        if (res.status === 429 || res.status >= 500 || type.indexOf('json') === -1) return fail(res.status >= 400 ? res.status : 500);
        /* Shopify's own reason (for example "sold out" or "only 3 left"). The theme shows `message`, which Shopify
           often fills with the bare "Cart Error", so the specific description is moved into it and announced. */
        return res.clone().json().then(function (d) {
          if (!d || typeof d !== 'object') return res;
          var text = (typeof d.description === 'string' && d.description) || d.message || ADD_ERROR;
          d.message = text;
          d.status = d.status || res.status;
          alertPage(text);
          return new Response(JSON.stringify(d), { status: res.status, headers: { 'Content-Type': 'application/json' } });
        }, function () { return fail(res.status); });
      }, function () { return fail(503); });
    };
    wrapped.__ryc = true;
    window.fetch = wrapped;
  }

  function init() {
    initDrawer();
    $$('[data-ryc-discount]').forEach(initDiscount);
    $$('[data-ryc-note]').forEach(initNote);
    watchTotals();
    watchCount();
  }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', init);
  else init();
  doc.addEventListener('shopify:section:load', init);
})();
